import { AuthorizationService } from 'app/core/ana/authorization';
import { environment } from 'environments/environment';

// Angular
import { ChangeDetectorRef, Component, OnInit, ViewRef } from '@angular/core';
import { finalize, switchMap } from 'rxjs/operators';
import { RestorationDbService } from 'app/core/o2c/admin/_services/restoration-db.service';
import { EntitiesAccessService } from 'app/core/common/_services/entities-access.service';

@Component({
  standalone: false,
    selector: 'kt-topbar',
    templateUrl: './topbar.component.html',
    styleUrls: ['./topbar.component.scss'],
})
export class TopbarComponent implements OnInit {
	isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    /**
     * Store response of auth for the actual user
     */
    authorizedUserForNotifications: boolean;
    restorationDate: string;
    isRedHost(): boolean {
        return environment.host === 'https://fyf-dev.fyffes-na.com/fyffesna/';
    }
    isBlueHost(): boolean {
        return environment.host === 'https://fyf-qas.fyffes-na.com/fyffesna/';
    }



    constructor(
        private authorization: AuthorizationService,
        private changeDetectorRef: ChangeDetectorRef,
        private restorationDbService: RestorationDbService
    ) { }

    ngOnInit(): void {
		this.getAuthorizationForMessages();
		if(!environment.production)
		{
				this.getRestorationDate();
		}
    }
	isProduction()
	{
		return environment.production;
	}

    /**
     * Obtain an auth for messages/notifications with the actual user
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-11-17
     */
    getAuthorizationForMessages(): void {
        const username = localStorage.getItem('user');
        const componentOfNotifications = '/processing/messages';
        const appOfNotifications = environment.host + 'o2c';
        this.authorization.isAuthorized(username, componentOfNotifications, appOfNotifications)
            .pipe(
                finalize(() => {
                    this.updateDOM();
                })
            )
            .subscribe(
                isAuthorized => {
                    this.authorizedUserForNotifications = isAuthorized;
                }
            );
    }

    /**
     * Get restore date
     * @author Castor Transformación Digital - Ana Quiñones
     * @since 2024-03-20
     */
    getRestorationDate(): void {        
        this.restorationDbService.getRestorationDate()
            .subscribe(
                (response: string) => {
                    this.restorationDate = response;
                    this.updateDOM();
                },
            (error) => {
              console.error('Error fetching restoration date:', error);
            }
        );
      }


    /**
     * Checks if theres a new change in the dom to be forced
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-03-20
     */
    public updateDOM(): void {
        if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) {
            this.changeDetectorRef.detectChanges();
        }
    }
}
